import { HttpError } from 'util/error'

export type ExtractResponse<T> = (response: Response) => Promise<T>
export type Tune<T = unknown> = {
  extend?: false
  extract?: ExtractResponse<T>
}

export async function fetchJson<T>(url: string, options: RequestInit = {}, tune?: Tune<T>): Promise<T> {
  const response = await fetch(url, { ...options })
  if (response.ok) {
    if (tune?.extract) return await tune.extract(response)
    return await response.json()
  }
  const { status } = response
  let text = ''
  try {
    text = await response.text()
  } catch {
  }
  throw new HttpError(status, text)
}
